<template>
  <div class="rc-top">
    <div class="rc-container">
      <div class="code-container">
        <div class="code">
          <div class="rc-datetime">{{ getCurrentDate() }}</div>
          <div class="rc-count-checkin">
            {{
              $t('top-receptionist-page.receptionist-count-title', {
                split: '/'
              })
            }}：<span class="number"> {{ getLengthListCheckIn }}</span>
            {{
              $t('top-receptionist-page.receptionist-person-title', {
                split: '/'
              })
            }}
          </div>
          <div class="rc-count-checkin-icon">
            {{
              $t('top-receptionist-page.receptionist-count-title', {
                split: '/'
              })
            }}： <span class="number"> {{ getLengthListCheckIn }}</span>
            <v-icon color="red" size="17" class="ml-2">
              mdi-account-multiple
            </v-icon>
          </div>

          <div class="code-info">
            <router-link tag="button" :to="pathHome + '/qr-scan'">
              <v-btn color="#e8320d" height="70">
                {{
                  $t('login-receptionist-page.btn-use-qr', {
                    split: '/'
                  })
                }}
              </v-btn>
            </router-link>
            <div class="mt">
              <router-link tag="button" :to="pathHome + '/code-scan'">
                <v-btn
                  class="btn-code"
                  color="#e8320d"
                  height="70"
                  v-html="
                    $t('login-receptionist-page.btn-use-code-manual', {
                      split: '<br />'
                    })
                  "
                >
                </v-btn>
              </router-link>
            </div>
          </div>

          <div class="list-status">
            <router-link tag="a" :to="pathHome + '/receptionist-status'">
              {{
                $t('top-receptionist-page.list-status-label', {
                  split: '/'
                })
              }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { LANG_CODE_JAPANESE } from '@/common/constants';
export default {
  name: 'Receptionist-HomePage',
  data() {
    return {
      birthday: new Date().toISOString().substr(0, 10),
      tableData: []
    };
  },
  methods: {
    getCurrentDate() {
      let string = '';
      const datetime = this.formatDate(new Date().toISOString().substr(0, 10));
      if (this.checkDateFormate(datetime)) {
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('/');
          string =
            year +
            this.$t('list-receptionist-page.year') +
            month +
            this.$t('list-receptionist-page.month') +
            day +
            this.$t('list-receptionist-page.day');
        } else {
          const [day, month, year] = datetime.split('/');
          string =
            this.$t('list-receptionist-page.day') +
            ' ' +
            day +
            ' ' +
            this.$t('list-receptionist-page.month') +
            ' ' +
            month +
            ' ' +
            this.$t('list-receptionist-page.year') +
            ' ' +
            ' ' +
            year;
        }
        return string;
      }
    }
  },
  created() {
    const data = {
      event_id: this.checkEvent.event_id,
      date: this.birthday,
      time_zone: this.m_event.time_zone
    };
    this.$store.dispatch('listReceptionCheckInApplicant', data);
  },
  watch: {
    dataListCheckIn: function (val) {
      if (val) {
        return (this.tableData = Object.assign([], val));
      }
    }
  },
  computed: {
    getLengthListCheckIn() {
      const arr = this.tableData;

      return arr.length;
    },
    ...mapGetters({
      dataListCheckIn: 'getDataListCheckInReception'
    })
  }
};
</script>

<style lang="scss">
@import '@/style/common.scss';
@import '@/style/devices.scss';
.rc-top {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  .rc-container {
    width: 80vw;
    margin-top: 50px;

    .rc-datetime {
      color: #e8320d;
      font-size: 30px;
      text-align: center;
    }
    .rc-count-checkin {
      color: #e8320d;
      font-size: 30px;
      text-align: center;
      margin: 10px auto;
    }

    .rc-count-checkin-icon {
      display: none;
      color: #e8320d;
      font-size: 30px;
      text-align: center;
      margin: 10px auto;
    }

    .code-container {
      background: $secondary_blue;
      padding: 24px 0;
      display: flex;
      justify-content: center;

      .code {
        background: #fff;
        border-radius: 10px;
        border: 1px dashed $bold_blue;
        padding: 34px 60px;
        position: relative;
        z-index: 0;
        width: 140% !important;
        max-width: 550px;

        h3 {
          padding-bottom: 22px;
          border-bottom: 1px dashed $bold_blue;
        }

        .code-info {
          .mt {
            margin-top: 50px;
          }
          .v-btn {
            width: 350px;
            color: #fff;
            text-transform: unset !important;
          }
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .orderCode {
            color: #fff;
            width: 85%;
            height: 70px;
            font-weight: 900;
            font-size: 40px;
          }

          .title {
            font-weight: 500;
            font-size: 14px !important;
            margin-top: 40px;
            text-align: center;
          }

          .qr-box {
            overflow: hidden;
            background: #fff;
            box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            width: 50%;
            img {
              width: 100%;
            }
          }
        }
        .list-status {
          width: 100%;
          text-align: center;
          padding-bottom: 20px;
          font-size: 20px;
        }
      }
    }
  }
}

@include mobile {
  .rc-top {
    .rc-datetime {
      font-size: 20px !important;
    }
    .rc-count-checkin {
      font-size: 20px !important;
    }
    .rc-count-checkin-icon {
      font-size: 20px !important;
    }
    .rc-container {
      width: 100vw;
      .rc-datetime {
        margin-top: 25px !important;
      }
      .rc-count-checkin {
        display: none !important;
      }
      .rc-count-checkin-icon {
        display: block !important;
      }

      .code-container {
        padding: 50px 25px !important;
        // height: calc(100vh - 50px);
        .code-info {
          .v-btn {
            height: 50px !important;
            font-size: 13px !important;
            width: 250px !important;
            color: #fff;
          }
        }
        .list-status {
          font-size: 13px !important;
        }
        .code {
          padding: unset !important;
        }
      }
    }
  }
}
</style>
